import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Container,
  Dropdown,
  Row,
  Spinner,
} from "react-bootstrap";
import styles from "./roundMultiplier.module.scss";
// img
// import p1 from "../../../assets/images/current.png";
// import diamond from "../../../assets/images/diamond.png";
import GameHistoryDetailPop from "../../../components/Modals/GameHistoryDetailPop";
import { useDispatch, useSelector } from "react-redux";
import { copyToClipboard, showToast, wait } from "../../../helper/common";
import moment from "moment";
import InfiniteScroll from "react-infinite-scroll-component";
import LoaderCstm from "../../../components/Loader";
import { gameSlice } from "../../../lib/store/game/slice";
import { useNavigate } from "react-router-dom";
import { useWindow } from "../../../hooks/useWindow";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../hooks/useLanguage";
import {
  getRoundMultiplier,
  getSelectRoundMultiplier,
  removeSelectRoundMultiplier,
} from "../../../lib/store/roundmultiplier/actions";
import RoundMultiplierPop from "../../../components/Modals/RoundeMultiplierPop";

const RoundMultiplerPage = () => {
  // const { t } = useTranslation();
  const t = useLanguage();

  const navigate = useNavigate();
  const [roundDetail, setRoundDetail] = useState(false);
  const [roundDetailData, setRoundDetailData] = useState(false);

  const dispatch = useDispatch();
  const { user, roundMultiplierList, totalRoundMultiplier,myRoundMultiplier, loading } =
    useSelector(({ Auth, RoundMultiplier }) => ({
      user: Auth.user,
      loading: RoundMultiplier.loading,
      roundMultiplierList: RoundMultiplier?.roundMultiplierList,
      myRoundMultiplier: RoundMultiplier?.myRoundMultiplier,
      totalRoundMultiplier: RoundMultiplier?.totalRoundMultiplier,
    }));
  const [filter, setFilter] = useState({
    page: 1,
    limit: 20,
    order: -1,
    orderBy: "date_created_utc",
    search: "",
    status: "",
  });
  const [selectedRow, setSelectedRow] = useState(null);

  const handleSelectRow = (item) => {
    dispatch(
      getSelectRoundMultiplier({
        id: item?._id,
        callBack: (err, res) => {
          if (!err) {
            // setSelectedRow(item._id);
            dispatch(getRoundMultiplier({ data: filter, userId: user?._id }));
          }
        },
      }),
    );
  };

  const handleRemoveSelectionRow = (item) => {
    dispatch(
      removeSelectRoundMultiplier({
        id: item?._id,
        callBack: (err, res) => {
          if (!err) {
            // setSelectedRow(item._id);
            dispatch(getRoundMultiplier({ data: filter, userId: user?._id }));
          }
        },
      }),
    );
  };

  useEffect(() => {
    dispatch(getRoundMultiplier({ data: filter, userId: user?._id }));
  }, [filter, user, dispatch]);

  useEffect(() => {
    setSelectedRow(
      myRoundMultiplier?.roundMultiplier || null,
    );
  }, [myRoundMultiplier]);

  const fetchMore = async () => {
    await wait(1000);
    setFilter((prev) => ({ ...prev, page: prev.page + 1 }));
  };

  const onClosePop = () => {
    setRoundDetail(false);
  };

  const onOpenRoundMultiplierPop = (row) => {
    setRoundDetail(true);
    setRoundDetailData(row)
  };

  const onCopy = async (value) => {
    try {
      const message = await copyToClipboard(value);
      // addToast(message, 'success', 3000);
      showToast(message, "success");
    } catch (err) {
      // addToast(err, 'error', 3000);
      showToast(typeof err === "string" ? err : err?.message, "error");
    }
  };
  useEffect(() => {
    //
    document.body.classList.add("includeHeader");

    // Cleanup: Remove the class when the component unmounts asdfasdf
    return () => {
      document.body.classList.remove("includeHeader");
    };
  }, []);

  const {
    screenSize: { dynamicHeight },
  } = useWindow();
  const elementRef = useRef(null); // Create a ref for the element
  const scrollStopOn =
    dynamicHeight - 230 > elementRef.current?.offsetHeight ? true : false;

  return (
    <>
      <section
        className={`${styles.gameHistory} gameHistory ${
          scrollStopOn && totalRoundMultiplier <= 20 ? "no-minimize" : ""
        }`}
      >
        {roundDetail && (
          <RoundMultiplierPop data={roundDetailData} show={roundDetail} onHide={onClosePop} />
        )}

        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className={`${styles.cardCstm} py-2 cardCstm`}>
                <div className="top pb-3 text-center position-relative">
                  <Button
                    onClick={() => navigate("/game")}
                    className="border-0 p-0 position-absolute "
                    variant="transparent"
                    style={{ top: 0, left: 10 }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="15"
                      viewBox="0 0 14 20"
                      fill="none"
                    >
                      <path
                        d="M2.91436 9.76907L12.1877 2.01034C12.4158 1.81953 12.4158 1.5135 12.1877 1.32268C11.9596 1.13186 11.5939 1.13186 11.3658 1.32268L1.67935 9.42704C1.45128 9.61785 1.45128 9.92388 1.67935 10.1147L11.3658 18.2155C11.4777 18.3091 11.6283 18.3595 11.7746 18.3595C11.9209 18.3595 12.0715 18.3127 12.1834 18.2155C12.4115 18.0246 12.4115 17.7186 12.1834 17.5278L2.91436 9.76907Z"
                        fill="white"
                        stroke="white"
                        strokeWidth="2.26051"
                      />
                    </svg>
                  </Button>
                  <p
                    className="m-0 fw-bold d-inline-block pb-1"
                    style={{
                      // borderBottom: "1px solid #02ADEA",
                      color: "#54B3F5",
                    }}
                  >
                    {t("roundMultiplier.title")}
                  </p>
                </div>
                {loading && filter.page === 1 && <LoaderCstm />}
                <InfiniteScroll
                  dataLength={roundMultiplierList?.length}
                  next={fetchMore}
                  hasMore={roundMultiplierList?.length < totalRoundMultiplier}
                  scrollThreshold={0}
                  scrollableTarget="historyList"
                  loader={
                    loading &&
                    filter.page >= 2 && (
                      <div className="d-flex justify-content-center align-items-center">
                        <Spinner className={styles.mSpinner} size="sm" />
                      </div>
                    )
                  }
                >
                  <div
                    id="historyList"
                    className="table-responsive allow-scroll"
                    style={{
                      overflowY: "scroll",
                      height: "calc(100vh - 230px)",
                    }}
                  >
                    <table ref={elementRef} className="table text-center">
                      <thead className="no-minimize">
                        <tr>
                          <th className="border-0 bg-transparent fw-normal text-white">
                            {t("roundMultiplier.round_type")}
                          </th>
                          <th className="border-0 bg-transparent fw-normal text-white">
                            {t("roundMultiplier.energy_spent")}
                          </th>
                          <th className="border-0 bg-transparent fw-normal text-white">
                            {t("roundMultiplier.action")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {roundMultiplierList?.map((item, index) => (
                          <tr
                            className={
                              selectedRow === item._id
                                ? styles.hightlightRow
                                : ""
                            }
                            key={"history" + index}
                          >
                            <td className="border-0 bg-transparent px-2 py-3">
                              <h6 className="cursor-pointer m-0 fw-normal text-white">
                                {item?.roundType}{" "}
                              </h6>
                            </td>
                            <td className="border-0 bg-transparent px-2 py-3">
                              <h6 className="m-0 fw-normal text-white">
                                {item?.energySpent}
                              </h6>
                            </td>
                            <td className="border-0 bg-transparent px-2 py-3">
                              <div className="d-flex align-items-center justify-content-center gap-10">
                                <Button
                                  onClick={() => onOpenRoundMultiplierPop(item)}
                                  variant="transparent"
                                  className="border-0 p-0"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19"
                                    height="10"
                                    viewBox="0 0 19 10"
                                    fill="none"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M4.50784 7.23569C3.1735 6.41775 2.22044 5.48287 1.77333 5C2.22044 4.51713 3.1735 3.58224 4.50784 2.76434C5.88545 1.91991 7.58648 1.25 9.49997 1.25C11.4135 1.25 13.1146 1.91991 14.4922 2.76434C15.8266 3.58224 16.7796 4.51713 17.2267 5C16.7796 5.48287 15.8266 6.41775 14.4922 7.23569C13.1146 8.08012 11.4135 8.75 9.49997 8.75C7.58648 8.75 5.88545 8.08012 4.50784 7.23569ZM9.49997 0C7.00111 0 4.90705 0.871638 3.36605 1.81622C1.81946 2.76423 0.746216 3.836 0.269914 4.35612C-0.0899714 4.74906 -0.0899714 5.25094 0.269914 5.64388C0.746216 6.164 1.81946 7.23575 3.36605 8.18381C4.90705 9.12838 7.00111 10 9.49997 10C11.9989 10 14.093 9.12838 15.634 8.18381C17.1806 7.23575 18.2538 6.164 18.7301 5.64388C19.09 5.25094 19.09 4.74906 18.7301 4.35612C18.2538 3.836 17.1806 2.76423 15.634 1.81622C14.093 0.871638 11.9989 0 9.49997 0ZM7.74789 5C7.74789 4.30963 8.53239 3.75 9.49997 3.75C10.4676 3.75 11.2521 4.30963 11.2521 5C11.2521 5.69037 10.4676 6.25 9.49997 6.25C8.53239 6.25 7.74789 5.69037 7.74789 5ZM9.49997 2.5C7.56472 2.5 5.99585 3.61929 5.99585 5C5.99585 6.38069 7.56472 7.5 9.49997 7.5C11.4353 7.5 13.0041 6.38069 13.0041 5C13.0041 3.61929 11.4353 2.5 9.49997 2.5Z"
                                      fill="#9DA1C3"
                                    />
                                  </svg>
                                </Button>
                                {selectedRow !== item._id ? (
                                  <Button
                                    className="border-0 p-0"
                                    variant="transparent"
                                    onClick={() => handleSelectRow(item, index)}
                                  >
                                    {tickIcn}
                                  </Button>
                                ) : (
                                  <Button
                                    className="border-0 p-0"
                                    variant="transparent"
                                    onClick={() =>
                                      handleRemoveSelectionRow(item, index)
                                    }
                                  >
                                    {crossIcn}
                                  </Button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </InfiniteScroll>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default RoundMultiplerPage;

const tickIcn = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.75 8.75L6.25 12.25L13.25 4.75"
      stroke="#54B3F5"
      strokeWidth="1.5"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const crossIcn = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3332 13.3337L2.6665 2.66699M13.3332 2.66699L2.6665 13.3337"
      stroke="#FF2222"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
